'use client';

import styled from './FavoritesExpand.module.scss';
import { useState, useTransition } from "react";
import { usePathname, useRouter } from "next/navigation";
import { IconFavorites } from '@/public/assets/icons/IconFavorites';
import classNames from 'classnames';
import { LinearProgress } from '@mui/material';



export function FavoritesExpand() {
  const [isPending, startTransition] = useTransition();
  const router = useRouter();
  const fullPathname = usePathname();
  const pathname = '/favorites';
  const title =  'Избранное';
  async function handleSetPathname() {
    if (pathname === fullPathname) return;

    startTransition(() => {
      router.push(pathname);
    });
  }

  return (
    <button className={styled.button}  onClick={() => handleSetPathname()}>
      <div  className={classNames(fullPathname.includes(pathname) ? styled.button_box_active : styled.button_box)}>
        <IconFavorites width={'18px'} height={'18px'}/>
        {isPending ? (
          <div style={{ width: '180px', height: '30px', paddingTop: '15px' }}><LinearProgress style={{ color: 'var(--sapphire-20)' }}/></div> 
        ) : (<>{ title }</>)}
      </div>
      {/* {!isPending && (
        <div className={styled.button_info}>
              80
        </div>
      ) } */}
    </button>
      
  );
}
